import _ from 'lodash/fp';

export const getRoomBySlotId = (rooms, id) =>
  _.find(r => _.some({id}, r.productSlots), rooms);

const slotRowsToProductRows = rooms =>
  _.map(row => {
    const room = getRoomBySlotId(rooms, row.productSlotId);
    const slot = _.find({id: row.productSlotId}, room.productSlots);
    return {
      ...row,
      room,
      slot,
      unit: row.unit || (!!slot ? slot.unit : ''),
      quantity: row.quantity || (!!slot ? slot.quantity : 0),
    };
  });

export const rowsToProductRows = rooms =>
  _.map(row => ({
    ...row,
    room: row.room || _.find({id: row.roomId}, rooms),
  }));

export const productRowsByRoom = (rooms, rows, extraRows) => {
  const productRows = _.flow(
    slotRowsToProductRows(rooms),
    _.sortBy([
      'room.sortIndex',
      'slot.sortIndex',
      r => !!r.slot && !!r.slot.advanced
        ? !!r.parentConfigId
        : true,
      r => !!r.slot && !!r.slot.advanced
        ? r.productType.name
        : true,
    ]),
  )(rows);
  const extraProductRows = _.flow(rowsToProductRows(rooms), _.sortBy(['room.sortIndex']))(extraRows);

  return _.flow(
    _.reduce((list, room) => {
      const roomProductRows = _.filter(r => r.room.id === room.id, productRows);
      const roomExtraProductRows = _.filter(r => r.room.id === room.id, extraProductRows);
      if (roomProductRows.length || roomExtraProductRows.length) {
        return [...list, {...room, productRows: roomProductRows, extraProductRows: roomExtraProductRows}];
      }
      return list;
    }, []),
    _.sortBy(['sortIndex']),
  )(rooms);
};



// WEBPACK FOOTER //
// ./src/reducers/helpers.js